"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable no-param-reassign */
var Leaf = function Leaf(_ref) {
  var attributes = _ref.attributes,
      children = _ref.children,
      leaf = _ref.leaf;

  if (leaf.bold) {
    children = /*#__PURE__*/_react["default"].createElement("strong", null, children);
  }

  if (leaf.code) {
    children = /*#__PURE__*/_react["default"].createElement("code", null, children);
  }

  if (leaf.italic) {
    children = /*#__PURE__*/_react["default"].createElement("em", null, children);
  }

  if (leaf.underline) {
    children = /*#__PURE__*/_react["default"].createElement("u", null, children);
  }

  return /*#__PURE__*/_react["default"].createElement("span", attributes, children);
};

var _default = Leaf;
exports["default"] = _default;